import { apiClient } from "lib/apiClient";

export enum PortfolioDealStatusEnum {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
  DELETED = "DELETED",
}

export interface IPortfolioCompetitor {
  id: string;
  name: string;
}

export interface IPortfolioSubject {
  id: string;
  name: string;
  selected: boolean;
  competitors: IPortfolioCompetitor[];
}

export interface IPortfolioDeal {
  id: string;
  name: string;
  status: PortfolioDealStatusEnum;
  selected: boolean;
  subjects: IPortfolioSubject[];
}

export interface IPortfolioSelection {
  deals: IPortfolioDeal[];
}

export const getPortfolioSelection = async (): Promise<IPortfolioSelection> => {
  const response = await apiClient.get("/portfolio/selection");

  return response.data;
};
